/**
 * @author Bleddyn Pijpers <bleddyn@acato.nl>
 * @contributor Paul van Impelen <paul@acato.nl>
 */
export default class FooterAccordionFocus {

  constructor() {
    this.footer = document.querySelector( '.denhaag-footer--mega' )

    if (!this.footer) {
      // Current theme or child-theme doesn't have a footer.
      return
    }

    this.accordionHeaders = Array.from(this.footer.getElementsByClassName( 'denhaag-link-group__caption' ));
    this.breakpoint = 1053;

    this.windowEvents();
  }

  /**
   * Insert newly created button in the footer.
   * @param {HTMLElement} el The heading element where we take the innerText from.
   * @return {*}
   */
  insertButton(el) {
    const buttonElement = document.createElement( 'button' );
    buttonElement.setAttribute( 'aria-expanded', 'false' );
    buttonElement.classList.add( 'denhaag-footer__a11y-button' );
    buttonElement.classList.add( 'utrecht-heading-3' );
    buttonElement.innerText = el.innerText;
    return buttonElement;
  }

  /**
   * Remove the button from the footer.
   * @param {HTMLElement} heading The element we check for the button where we set the innerText to.
   * @param {HTMLElement} btn The button element to remove.
   */
  removeButton(heading, btn) {
    if (!heading || !btn) return;
    heading.innerText = btn.innerText;
    btn.remove();
  }

  /**
   * Disable focus on the footer heading and remove button.
   * @param {HTMLElement} heading The heading element.
   */
  disableFocus(heading) {
    if (!heading) return;
    const a11yButton = heading.querySelector( '.denhaag-footer__a11y-button' );
    if (!!a11yButton) {
      this.removeButton( heading, a11yButton );
    }
  }

  /**
   * Enable focus on the footer heading and add the button.
   * @param {HTMLElement} heading The heading element.
   */
  enableFocus(heading) {
    if (!heading) return;
    let a11yButton = heading.querySelector( '.denhaag-footer__a11y-button' );
    if (!a11yButton) {
      const newA11YButton = this.insertButton( heading );
      heading.innerText = '';
      heading.appendChild( newA11YButton );
    }
  }

  enableOrDisable() {
    if (window.innerWidth < this.breakpoint) {
      this.accordionHeaders?.forEach( header => this.enableFocus( header ) );
    } else {
      this.accordionHeaders?.forEach( header => this.disableFocus( header ) );
    }
  }

  /**
   * The window events.
   */
  windowEvents() {
    if( this.accordionHeaders.length === 0 ) {
      return;
    }

    this.enableOrDisable();
    window.addEventListener( 'dh:resize', this.enableOrDisable.bind( this ) );
  }
}
